export default __webpack_public_path__ + "static/media/Chat-new 1.277076d7.svg";